// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__01B7W"};